export default __webpack_public_path__ + "static/media/671.330ec75f.png";